import { LocaleContext } from "contexts"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { useContext } from "react"

export const Report2023Cover = ({ className }) => {
  const { locale } = useContext(LocaleContext)
  const images = useStaticQuery(graphql`
    {
      report_cover_fi: file(
        relativePath: { eq: "eu-report-2023-cover-horiz.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 90, width: 504)
        }
      }
      report_cover_sv: file(
        relativePath: { eq: "eu-report-2023-cover-horiz-sv.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 90, width: 504)
        }
      }
      report_cover_sv_se: file(
        relativePath: { eq: "eu-report-2023-cover-horiz-sv.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 90, width: 504)
        }
      }
    }
  `)

  let image

  switch (locale) {
    case "fi-fi":
      image = images.report_cover_fi
      break
    case "sv-fi":
      image = images.report_cover_sv
      break
    case "sv-se":
      image = images.report_cover_sv_se
      break
    default:
      image = images.report_cover_fi
  }

  return (
    <GatsbyImage
      image={getImage(image)}
      imgStyle={{
        objectFit: "cover",
        objectPosition: "right center",
      }}
      className={className}
      alt="EU report cover"
    />
  )
}
